export class DocScanWebComponentTextResult {
  // public comparisonStatus: number;
  public fieldName: string;
  public fieldType: number;
  // public lcid: number;
  public status: number;
  // public validityStatus: number;
  public value: string;
}

export class DocScanWebComponentImageResult {
  public base64: string;
  public type: string;

  constructor(base64: string, type: string) {
    this.base64 = base64;
    this.type = type;
  }
}

export class DocScanWebComponentResult {
  public text: DocScanWebComponentTextResult[];
  public images: DocScanWebComponentImageResult[];
}

export class DocScanWebServiceResult {
  key: string;
  value: string;
}

export enum DocumentScanningStatus {
  Pending,
  InProgress,
  Success,
  Error
}

export interface GetShortUrlResult {
  shortUrl: string
}
